import { render, staticRenderFns } from "./editLiveVideo.vue?vue&type=template&id=16fde523&scoped=true&"
import script from "./editLiveVideo.vue?vue&type=script&lang=js&"
export * from "./editLiveVideo.vue?vue&type=script&lang=js&"
import style0 from "./editLiveVideo.vue?vue&type=style&index=0&id=16fde523&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fde523",
  null
  
)

export default component.exports